module.exports = __webpack_public_path__ + "media/images/sms-68bf559c2c8bcf46b24413100583b36b.png";